import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { LocationCategoryService } from '../location-category.service'


@Component({
  selector: 'app-location-category-table',
  templateUrl: './location-category-table.component.html',
  styleUrls: ['./location-category-table.component.scss']
})
export class LocationCategoryTableComponent implements OnInit {

  displayedColumns: string[] = ['id', 'name'];
  dataSource: any;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private global: GlobalService, private http: HttpService, public locationCategoryService: LocationCategoryService) {
    this.getLocationCategory();
    this.global.set_master_page_title = 'Location Category';
    this.locationCategoryService.downloadLocationCategory.subscribe((is_new_location_category_present) => {
      console.log(is_new_location_category_present);
      if (is_new_location_category_present) {
        this.getLocationCategory();
      }
    });
  }
  
  getLocationCategory() {
    this.http.getLocationCategories().subscribe((data: LocationCategory[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<LocationCategory>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  registerLocationCategory() {
    console.log('click for register relation type')
    this.showLocationCategoryRegister();
    this.locationCategoryService.LocationCategoryUpdate.emit(null);
    this.locationCategoryService.set_location_category_data = null;
  }


  editLocationCategory(relation_type) {
    this.showLocationCategoryRegister();
    this.locationCategoryService.LocationCategoryUpdate.emit(relation_type);
    this.locationCategoryService.set_location_category_data = relation_type;
  }

  showLocationCategoryRegister() {
    this.locationCategoryService.is_display_location_category_register_component = true;
  }

  hideLocationCategoryRegister() {
    this.locationCategoryService.is_display_location_category_register_component = false;
  }


  ngOnInit() {
  }

}


export interface LocationCategory {
  id: number;
  name: string;
}
